/// <reference types="vite-plugin-svgr/client" />
import { default as AlarmClockOutlineIcon } from "./alarm-clock-solid.svg?react";
import { default as AlarmClockSolidIcon } from "./alarm-clock-solid.svg?react";
import { default as ArrowLeftSolidIcon } from "./arrow-left-solid.svg?react";
import { default as ArrowRightSolidIcon } from "./arrow-right-solid.svg?react";
import { default as CalendarOutlineIcon } from "./calendar-outline.svg?react";
import { default as CalendarSolidIcon } from "./calendar-solid.svg?react";
import { default as ChevronDownSolidIcon } from "./chevron-down-solid.svg?react";
import { default as ChevronLeftSolidIcon } from "./chevron-left-solid.svg?react";
import { default as ChevronRightSolidIcon } from "./chevron-right-solid.svg?react";
import { default as ChevronUpSolidIcon } from "./chevron-up-solid.svg?react";
import { default as ClockOutlineIcon } from "./clock-outline.svg?react";
import { default as ClockSolidIcon } from "./clock-solid.svg?react";
import { default as DebitCardReverseOutlineIcon } from "./debit-card-reverse-outline.svg?react";
import { default as MapPinOutlineIcon } from "./map-pin-outline.svg?react";
import { default as MapPinSolidIcon } from "./map-pin-solid.svg?react";
import { default as StopwatchOutlineIcon } from "./stopwatch-outline.svg?react";
import { default as TickSolidIcon } from "./tick-solid.svg?react";
import { default as UserSolidIcon } from "./user-solid.svg?react";
import { default as WarningIcon } from "./warning.svg?react";
import { IconType } from "../../components/Icon/Icon";

const AlarmClockOutline = AlarmClockOutlineIcon as IconType;
AlarmClockOutline.className = "alarm-clock-outline";

const AlarmClockSolid = AlarmClockSolidIcon as IconType;
AlarmClockSolid.className = "alarm-clock-solid";

const ArrowLeftSolid = ArrowLeftSolidIcon as IconType;
ArrowLeftSolid.className = "arrow-left-solid";

const ArrowRightSolid = ArrowRightSolidIcon as IconType;
ArrowRightSolid.className = "arrow-right-solid";

const CalendarOutline = CalendarOutlineIcon as IconType;
CalendarOutline.className = "calendar-outline";

const CalendarSolid = CalendarSolidIcon as IconType;
CalendarSolid.className = "calendar-solid";

const ChevronDownSolid = ChevronDownSolidIcon as IconType;
ChevronDownSolid.className = "chevron-down-solid";

const ChevronLeftSolid = ChevronLeftSolidIcon as IconType;
ChevronLeftSolid.className = "chevron-left-solid";

const ChevronRightSolid = ChevronRightSolidIcon as IconType;
ChevronRightSolid.className = "chevron-right-solid";

const ChevronUpSolid = ChevronUpSolidIcon as IconType;
ChevronUpSolid.className = "chevron-up-solid";

const ClockOutline = ClockOutlineIcon as IconType;
ClockOutline.className = "clock-outline";

const ClockSolid = ClockSolidIcon as IconType;
ClockSolid.className = "clock-solid";

const DebitCardReverseOutline = DebitCardReverseOutlineIcon as IconType;
DebitCardReverseOutline.className = "debit-card-reverse-outline";

const MapPinOutline = MapPinOutlineIcon as IconType;
MapPinOutline.className = "map-pin-outline";

const MapPinSolid = MapPinSolidIcon as IconType;
MapPinSolid.className = "map-pin-solid";

const StopwatchOutline = StopwatchOutlineIcon as IconType;
StopwatchOutline.className = "stopwatch-outline";

const TickSolid = TickSolidIcon as IconType;
TickSolid.className = "tick-solid";

const UserSolid = UserSolidIcon as IconType;
UserSolid.className = "user-solid";

const Warning = WarningIcon as IconType;
UserSolid.className = "user-solid";

export {
  AlarmClockOutline,
  AlarmClockSolid,
  ArrowLeftSolid,
  ArrowRightSolid,
  CalendarOutline,
  CalendarSolid,
  ChevronDownSolid,
  ChevronLeftSolid,
  ChevronRightSolid,
  ChevronUpSolid,
  ClockOutline,
  ClockSolid,
  DebitCardReverseOutline,
  MapPinOutline,
  MapPinSolid,
  StopwatchOutline,
  TickSolid,
  UserSolid,
  Warning,
};
